"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ILLUSTRATION_TYPES: true,
  Illustration: true
};
exports.default = exports.Illustration = exports.ILLUSTRATION_TYPES = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _Illustration = require("./_Illustration.types");
Object.keys(_Illustration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Illustration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Illustration[key];
    }
  });
});
var _Illustration2 = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Illustration.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-illustration';
// TODO: This is necessary. We need to investigate why exporting directly from .types causes diffs in the visual regression tests
const ILLUSTRATION_TYPES = exports.ILLUSTRATION_TYPES = _Illustration.ILLUSTRATION_TYPES;
const Illustration = props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(Illustration, props)) : props,
    {
      ariaHidden,
      className,
      Component,
      screenReaderOnly,
      title,
      titleProps,
      variant
    } = _a,
    otherProps = __rest(_a, ["ariaHidden", "className", "Component", "screenReaderOnly", "title", "titleProps", "variant"]);
  let uniqueId = (0, _useUniqueId.default)();
  if (titleProps === null || titleProps === void 0 ? void 0 : titleProps.id) {
    uniqueId = titleProps.id;
  }
  const classnames = _bind.default.bind(_Illustration2.default);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, otherProps, {
    "aria-hidden": ariaHidden,
    role: "img",
    className: classnames(CSS_BLOCK, `${CSS_BLOCK}--${variant === null || variant === void 0 ? void 0 : variant.toLowerCase()}`, {
      [`${CSS_BLOCK}--screen-reader-only`]: screenReaderOnly
    }, className),
    "aria-labelledby": title && !ariaHidden ? uniqueId : undefined
  })), title && (/*#__PURE__*/_react.default.createElement("span", Object.assign({}, titleProps, {
    id: uniqueId,
    className: classnames(`${CSS_BLOCK}__title`, titleProps === null || titleProps === void 0 ? void 0 : titleProps.className)
  }), title)));
};
exports.Illustration = Illustration;
Illustration.displayName = 'Illustration';
var _default = exports.default = Illustration;